import { SxProps, Theme } from '@mui/material';

import { styledPriceText } from './PriceSection.styled';

export const animatedPriceContainerStyles: SxProps<Theme> = {
  ...styledPriceText,
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.1em',
};

export const currencySymbolStyles: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  lineHeight: 1,
};

export const priceSlotContainerStyles: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  fontWeight: 'inherit',
  lineHeight: 1.3,
  '& .price-slot-separator': {
    overflow: 'visible',
  },
};
